<template>
  <div class="card-body">
    <div class="row">
      <hull-inspection-editor
        ref="hullInspectionEditor"
        :hullInspection="hullInspection"
        :hullInspectionDocuments="hullInspectionDocuments"
      />
      <div class="col-12 mt-4 d-flex justify-content-end">
        <button class="btn btn-danger" type="button" @click="cancel">
          Cancel
        </button>
        <button class="btn btn-primary ms-3" type="submit" @click="saveDetails">
          Save
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import HullInspectionEditor from "./HullInspectionEditor.vue";

export default {
  name: "HullInspectionEditorModal",
  components: { HullInspectionEditor },
  props: {
    hullInspection: {
      type: Object,
    },
    hullInspectionDocuments: {
      type: Array,
      default: () => [],
    },
    onDelete: {
      type: Function,
      default: null,
    },
  },
  methods: {
    cancel() {
      if (!this.hullInspection.id) {
        this.onDelete();
      }
      this.close();
    },
    close(state = null) {
      this.$modal.hide("hull-inspection-editor-modal", state);
    },
    async saveDetails() {
      if (this.$refs.hullInspectionEditor.isInvalid()) return;

      this.close({ value: this.$refs.hullInspectionEditor.hullInspection_ });
    },
  },
};
</script>
